import { render, staticRenderFns } from "./Econimucs.vue?vue&type=template&id=4a5e41bb&scoped=true&"
import script from "./Econimucs.vue?vue&type=script&lang=js&"
export * from "./Econimucs.vue?vue&type=script&lang=js&"
import style0 from "./Econimucs.vue?vue&type=style&index=0&id=4a5e41bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5e41bb",
  null
  
)

export default component.exports